interface ISortOption<T> {
  accessorKey: keyof T;
  order: "asc" | "desc";
}

export const multiSort = <T>(data: T[], sortOptions: ISortOption<T>[]): T[] => {
  return [...data].sort((a, b) => {
    for (const { accessorKey, order } of sortOptions) {
      const valA = (a as any)[accessorKey];
      const valB = (b as any)[accessorKey];
      if (valA == null && valB != null) return order === "asc" ? -1 : 1;
      if (valB == null && valA != null) return order === "asc" ? 1 : -1;
      if (valA == null && valB == null) continue;
      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
    }
    return 0;
  });
};
